import React from 'react';
import { NavLink } from 'react-router-dom';

export default function AdminNavbarLinks({
  limitedAccess,
}: {
  limitedAccess: boolean;
}): JSX.Element {
  if (limitedAccess) {
    return <NavBarForLimitedAccess />;
  } else if (!limitedAccess) {
    return <NavBarForAdmin />;
  }
}

function NavBarForLimitedAccess(): JSX.Element {
  return (
    <div className="navbar__nav-links">
      <NavLink
        to="/dashboard"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Dashboard
      </NavLink>
      <NavLink
        to="/shift-planner"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Shift
      </NavLink>
      <NavLink
        to="/planner"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Planner
      </NavLink>
      <NavLink
        to="/hub"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Hub
      </NavLink>
      <NavLink
        to="/reports/courier"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Reports
      </NavLink>
      <NavLink
        to="/monitor"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Monitor
      </NavLink>
      <NavLink
        to="/users"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Users
      </NavLink>
    </div>
  );
}

function NavBarForAdmin(): JSX.Element {
  return (
    <div className="navbar__nav-links">
      <NavLink
        to="/dashboard"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Dashboard
      </NavLink>
      <NavLink
        to="/orders"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Orders
      </NavLink>
      <NavLink
        to="/shift-planner"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Shift
      </NavLink>
      <NavLink
        to="/planner"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Planner
      </NavLink>
      <NavLink
        to="/hub"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Hub
      </NavLink>
      <NavLink
        to="/warehouse"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Warehouse
      </NavLink>
      <NavLink
        to="/monitor"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Monitor
      </NavLink>

      <NavLink
        to="/reports"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Reports
      </NavLink>
      <NavLink
        to="/users"
        activeClassName="navbar__active-link"
        className="navbar__link"
      >
        Users
      </NavLink>
    </div>
  );
}
